
import { observable, action } from 'mobx';
import { plainToClassFromExist } from 'class-transformer';

import ArticleService from '../../service/ArticleService/ArticleService';
import QuestionService from '../../service/QuestionService';
/**
 * 获取登录二维码数据结构
 *
 ***/
export class CreateVideoState {
    @observable public video: string | null;
    @observable public videoName: string;
    @observable public videoCover: string;
    @observable public videoDesc: string;
    @observable public duration: string;
    @observable public videoId: string;
    @observable public pixel: string;
    @observable public progressCount: number = 0;
    @observable public videoSize: number = 0; // 字节
    @observable public uploadStatus: string | null = null;  // pending done error
    @observable public localPath: string | null;
    @observable public groupId: string | null;
    @observable public title: string | null;
    @observable public releaseType: string | null;
    @observable public releaseTime: string | null;
    @observable public frames: [] | null;
    @observable public loaded: string | null;

    @action public set_video(url) {
        this.video = url;
    }
    @action public set_uploadStatus(uploadStatus) {
        this.uploadStatus = uploadStatus;
    }
    @action public set_progress(num) {
        this.progressCount = num;
    }
    @action public set_videoSize(num) {
        this.videoSize = num;
    }
    @action public set_videoName(name) {
        this.videoName = name;
    }
    @action public set_videoCover(cover) {
        this.videoCover = cover;
    }
    @action public set_videoDesc(desc) {
        this.videoDesc = desc;
    }
    @action public keyValueChange(key,val) {
        this[key] = val;
    }
    @action public set_pixel(pixel) {
        this.pixel = pixel;
    }
    @action public set_duration(duration) {
        this.duration = duration;
    }
    @action public set_videoId(videoId) {
        this.videoId = videoId;
    }
    @action public set_localPath(localPath) {
        this.localPath = localPath;
    }
    @action public set_groupId(groupId) {
        this.groupId = groupId;
    }
    @action public set_release_type(releaseType) {
        this.releaseType = releaseType;
    }
    @action public set_release_time(releaseTime) {
        this.releaseTime = releaseTime;
    }
    @action public set_loaded(loaded) {
        this.loaded = loaded;
    }
}

// 视频发布

export class VideoRelease {
    @action public init(param, config?) {
        return ArticleService.videoRelease(param, config).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }
    @action public set_v2(param) {  // v2接口
        return QuestionService.publish_v2(param).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }
}
